let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u3.png'),
  name: 'Home sweet home',
  items: [],
};

export default itm;
